export default __webpack_public_path__ + "static/media/signinImg.54b7bdf5.svg";